import api from "@/app/api";
import { useApiCall } from "@/app/api/apiCall";
import { Link } from "@/app/components/Link";
import { SubmitButton } from "@/app/components/SubmitButton";
import { Unauth } from "@/app/components/Unauth";
import { useStandardToast } from "@/app/hooks/useStandardToast";
import { Text } from "@chakra-ui/react";
import { Form, FormLayout } from "@saas-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface SignUpPayload {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
}

export default function SignUp() {
  const [isSigningUp, setIsSigningUp] = useState<boolean>(false);
  const handle = useApiCall();
  const navigate = useNavigate();
  const toast = useStandardToast();
  const onSubmit = async (payload: SignUpPayload) => {
    setIsSigningUp(true);
    await handle(
      () =>
        api.signUp({
          ...payload,
          password2: payload.password,
        }),
      () => {
        navigate("/login");
        toast({
          title: "Please check your email for a verification link",
          status: "success",
        });
      },
      () => {
        setIsSigningUp(false);
      }
    );
  };

  return (
    <Unauth
      form={
        <Form
          onSubmit={onSubmit}
          defaultValues={{
            first_name: undefined,
            last_name: undefined,
            password: undefined,
            email: undefined,
          }}
        >
          {({ Field }) => (
            <FormLayout>
              <FormLayout columns={2}>
                <Field
                  name="first_name"
                  label="First name"
                  disabled={isSigningUp}
                  type="text"
                  rules={{
                    required: "First name is required.",
                  }}
                />
                <Field
                  name="last_name"
                  label="Last name"
                  disabled={isSigningUp}
                  type="text"
                  rules={{
                    required: "Last name is required.",
                  }}
                />
              </FormLayout>
              <Field
                name="email"
                label="Email address"
                type="text"
                disabled={isSigningUp}
                rules={{
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Please enter a valid email address",
                  },
                  required: "Email address is required.",
                }}
              />
              <Field
                name="password"
                label="Password"
                disabled={isSigningUp}
                type="password"
                rules={{
                  required: "Password is required.",
                }}
              />
              <SubmitButton isDisabled={isSigningUp}>
                Create an account
              </SubmitButton>
            </FormLayout>
          )}
        </Form>
      }
      footer={
        <Text fontSize="xs">
          Already have an account?{" "}
          <Link to="/login" data-cy="login-link">
            Login
          </Link>
        </Text>
      }
    />
  );
}
